export const ERROR = {
  ACCOUNT_ALREADY_IN_USE: 'Account is already in used. Choose another account please',
  INVALID_VERIFICATION_CODE: 'The code you supplied is incorrect ',
  INVALID_ACCOUNT_TYPE: 'The account you supplied is invalid',
  // USER_LIMIT: 'USER_LIMIT'
  USER_NOT_FOUND: 'No such user',
  // INVALID_LOGIN: ''
  INVALID_SEARCH_DATA: 'The input is invalid',
  PERMISSION_DENIED: 'You are NOT permitted for this action',
  ACCOUNT_NOT_FOUND: 'There is no such account',
  ANNOUNCEMENT_NOT_FOUND: 'Attachment NOT found',
  INVALID_TOKEN: 'Authentication failure, log in again.',
  ALREADY_IN_GROUP: 'You are aleady joined to this group',
  BLOCKED_FROM_CONV: 'You blocked from joining this group',
  GROUP_NOT_FOUND: 'No group was found with this code',
  INVALID_MATERIAL_TYPE: 'Not supported file type',
  LAST_ACCOUNT_REMOVE: 'You can NOT remove your last account',
  SERVER_NOT_WORKING: "Couldn't connect to the server. Ensure you are connted to the internet and try again"
};



// WEBPACK FOOTER //
// ./src/lang/en/error.js